import React, { useRef, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { ArticleInfo } from '../../../Modeles/ArticleModel';
import { Libraries, LoadScript, StandaloneSearchBox } from '@react-google-maps/api';
import * as XLSX from 'xlsx';
import axios from 'axios';
import { NewSideBarAdmin } from '../../NewSideBarAdmin';
import './CreateMagasin.css';

const CreateMagasinUpgraded: React.FC<ArticleInfo> = ({
  messageError,
  email,
  setemail,
  message,
  NomMagasin,
  tele,
  adresse,
  fax,
  Nom_complet_propriétaire,
  image,
  setMessageError,
  setMessage,
  setNomMagasin,
  settele,
  setadresse,
  setfax,
  setNom_complet_propriétaire,
  setImage,
  handleImage,
  setLatitude,
  setLongitude,
  handleSubmit,
}) => {

  const [showSuccessPopup, setShowSuccessPopup] = useState(false);
  const [previewImage, setPreviewImage] = useState<string | null>(null);
  const [isUploading, setIsUploading] = useState(false);
  const [dragActive, setDragActive] = useState(false);

  const searchBoxRef = useRef<google.maps.places.SearchBox | null>(null);
  const inputRef = useRef<HTMLInputElement>(null);
  const fileInputRef = useRef<HTMLInputElement | null>(null);
  const excelInputRef = useRef<HTMLInputElement | null>(null);

  const libraries: Libraries = ['places'];
  const navigate = useNavigate();

  const handlePlaceChanged = () => {
    const places = searchBoxRef.current?.getPlaces();
    if (places && places.length > 0) {
      const place = places[0];
      const formattedAddress = place.formatted_address || '';
      setadresse(formattedAddress);
      if (place.geometry && place.geometry.location) {
        const lat = place.geometry.location.lat();
        const lng = place.geometry.location.lng();
        setLatitude(lat);
        setLongitude(lng);
      }
    }
  };

  const handleImageChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    handleImage?.(e);
    const file = e.target.files?.[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setPreviewImage(reader.result as string);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleDrag = (e: React.DragEvent) => {
    e.preventDefault();
    e.stopPropagation();
    if (e.type === 'dragenter' || e.type === 'dragover') {
      setDragActive(true);
    } else if (e.type === 'dragleave') {
      setDragActive(false);
    }
  };

  const handleDrop = (e: React.DragEvent) => {
    e.preventDefault();
    e.stopPropagation();
    setDragActive(false);

    if (e.dataTransfer.files && e.dataTransfer.files[0]) {
      const file = e.dataTransfer.files[0];
      // Create a fake event to pass to handleImage
      const fakeEvent = {
        target: { files: [file] },
      } as any;
      handleImage?.(fakeEvent);

      const reader = new FileReader();
      reader.onloadend = () => {
        setPreviewImage(reader.result as string);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleRemoveImage = () => {
    setPreviewImage(null);
    if (fileInputRef.current) {
      fileInputRef.current.value = '';
    }
  };

  const handleExcelUpload = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (!file) return;

    setIsUploading(true);
    try {
      const data = await file.arrayBuffer();
      const workbook = XLSX.read(data);
      const sheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[sheetName];
      const jsonData = XLSX.utils.sheet_to_json(worksheet);

      await axios.post(
        `${process.env.REACT_APP_PHP_APP_URL}/admin/add/magasin/uploadExcel`,
        jsonData
      );

      setShowSuccessPopup(true);
      setTimeout(() => {
        setShowSuccessPopup(false);
        navigate(`/magasin`);
      }, 3000);
    } catch (error: any) {
      setMessageError(error.response?.data?.message || "Erreur lors de l'importation");
      setMessage('');
    } finally {
      setIsUploading(false);
      if (excelInputRef.current) {
        excelInputRef.current.value = '';
      }
    }
  };

  return (
    <>
      <NewSideBarAdmin />

      <div className="create-magasin-container">
        {/* Success Popup */}
        {showSuccessPopup && (
          <div className="success-popup-overlay">
            <div className="success-popup">
              <div className="success-icon">
                <i className="bi bi-check-circle-fill"></i>
              </div>
              <h3>Félicitations !</h3>
              <p>Le fichier a été importé avec succès</p>
              <div className="success-loader"></div>
            </div>
          </div>
        )}

        {/* Header Section */}
        <div className="create-header">
          <div className="header-top">
            <Link to="/magasin" className="back-button">
              <i className="bi bi-arrow-left"></i>
              Retour aux magasins
            </Link>
          </div>

          <div className="header-main">
            <div className="header-title-section">
              <h1 className="page-title">
                <i className="bi bi-shop"></i>
                Créer un nouveau magasin
              </h1>
              <p className="page-description">
                Remplissez les informations ci-dessous pour créer un nouveau magasin
              </p>
            </div>

            <div className="header-actions">
              <input
                ref={excelInputRef}
                id="excel-upload"
                type="file"
                accept=".xlsx, .xls"
                style={{ display: 'none' }}
                onChange={handleExcelUpload}
              />
              <button
                type="button"
                className="excel-import-btn"
                onClick={() => excelInputRef.current?.click()}
                disabled={isUploading}
              >
                {isUploading ? (
                  <>
                    <div className="btn-spinner"></div>
                    Import en cours...
                  </>
                ) : (
                  <>
                    <i className="bi bi-file-earmark-excel"></i>
                    Importer Excel
                  </>
                )}
              </button>
            </div>
          </div>
        </div>

        {/* Alerts */}
        {messageError && (
          <div className="alert alert-error">
            <i className="bi bi-exclamation-triangle-fill"></i>
            <span>{messageError}</span>
            <button
              onClick={() => setMessageError('')}
              className="alert-close"
              aria-label="Fermer le message d'erreur"
            >
              <i className="bi bi-x-lg"></i>
            </button>
          </div>
        )}

        {message && (
          <div className="alert alert-success">
            <i className="bi bi-check-circle-fill"></i>
            <span>{message}</span>
            <button
              onClick={() => setMessage('')}
              className="alert-close"
              aria-label="Fermer le message de confirmation"
            >
              <i className="bi bi-x-lg"></i>
            </button>
          </div>
        )}

        {/* Form Section */}
        <form onSubmit={handleSubmit} className="create-form">
          <div className="form-layout">
            {/* Left Column - Form Fields */}
            <div className="form-fields-section">
              <div className="form-card">
                <div className="form-card-header">
                  <h3>
                    <i className="bi bi-info-circle"></i>
                    Informations générales
                  </h3>
                </div>

                <div className="form-card-body">
                  <div className="form-group">
                    <label htmlFor="magasin-name">
                      Nom du magasin
                      <span className="required">*</span>
                    </label>
                    <input
                      id="magasin-name"
                      type="text"
                      onChange={(e) => setNomMagasin(e.target.value)}
                      className="form-input"
                      placeholder="Ex: Magasin Central"
                    />
                  </div>

                  <div className="form-group">
                    <label htmlFor="owner-name">
                      Nom complet du propriétaire
                      <span className="required">*</span>
                    </label>
                    <input
                      id="owner-name"
                      type="text"
                      onChange={(e) => setNom_complet_propriétaire(e.target.value)}
                      className="form-input"
                      placeholder="Ex: Ahmed Benali"
                    />
                  </div>

                  <div className="form-group">
                    <label htmlFor="email">
                      Adresse e-mail
                      <span className="required">*</span>
                    </label>
                    <div className="input-with-icon">
                      <i className="bi bi-envelope"></i>
                      <input
                        id="email"
                        type="email"
                        onChange={(e) => setemail(e.target.value)}
                        className="form-input with-icon"
                        placeholder="exemple@email.com"
                      />
                    </div>
                  </div>

                  <div className="form-group">
                    <label htmlFor="phone">
                      Numéro de téléphone
                      <span className="required">*</span>
                    </label>
                    <div className="input-with-icon">
                      <i className="bi bi-telephone"></i>
                      <input
                        id="phone"
                        type="tel"
                        onChange={(e) => settele(e.target.value)}
                        className="form-input with-icon"
                        placeholder="+212 6XX XXX XXX"
                      />
                    </div>
                  </div>

                  <div className="form-group">
                    <label htmlFor="location">
                      Localisation
                      <span className="required">*</span>
                    </label>
                    <div className="input-with-icon">
                      <i className="bi bi-geo-alt"></i>
                      {/* NOTE: the API key now reads from REACT_APP_GOOGLE_MAPS_API_KEY —
                          add it to your .env file. Shipping a Maps key directly in source
                          is a common source of quota abuse / billing surprises. */}
                      <LoadScript
                        googleMapsApiKey={process.env.REACT_APP_GOOGLE_MAPS_API_KEY || ''}
                        libraries={libraries}
                      >
                        <StandaloneSearchBox
                          onLoad={(ref) => (searchBoxRef.current = ref)}
                          onPlacesChanged={handlePlaceChanged}
                        >
                          <input
                            id="location"
                            type="text"
                            className="form-input with-icon"
                            placeholder="Rechercher une adresse..."
                            ref={inputRef}
                          />
                        </StandaloneSearchBox>
                      </LoadScript>
                    </div>
                    <small className="input-help">
                      <i className="bi bi-info-circle"></i>
                      Commencez à taper pour rechercher une adresse
                    </small>
                  </div>
                </div>
              </div>
            </div>

            {/* Right Column - Logo Upload */}
            <div className="logo-upload-section">
              <div className="form-card">
                <div className="form-card-header">
                  <h3>
                    <i className="bi bi-image"></i>
                    Logo du magasin
                  </h3>
                </div>

                <div className="form-card-body">
                  <div
                    className={`upload-area${dragActive ? ' drag-active' : ''}`}
                    onDragEnter={handleDrag}
                    onDragOver={handleDrag}
                    onDragLeave={handleDrag}
                    onDrop={handleDrop}
                  >
                    <input
                      ref={fileInputRef}
                      type="file"
                      accept="image/*"
                      id="logo-upload"
                      onChange={handleImageChange}
                      className="file-input-overlay"
                      aria-label="Choisir un logo pour le magasin"
                    />

                    {previewImage ? (
                      <div className="image-preview">
                        <img src={previewImage} alt="Aperçu du logo du magasin" />
                      </div>
                    ) : (
                      <>
                        <div className="upload-icon">
                          <i className="bi bi-cloud-arrow-up"></i>
                        </div>
                        <h4 className="upload-title">Glissez votre logo ici</h4>
                        <p className="upload-subtitle">ou cliquez pour parcourir vos fichiers</p>
                        <span className="upload-format">PNG, JPG jusqu'à 5MB</span>
                      </>
                    )}
                  </div>

                  {previewImage && (
                    <button
                      type="button"
                      className="remove-image-btn"
                      onClick={handleRemoveImage}
                    >
                      <i className="bi bi-trash"></i>
                      Supprimer l'image
                    </button>
                  )}
                </div>
              </div>
            </div>
          </div>

          {/* Form Actions */}
          <div className="form-actions">
            <Link to="/magasin" className="cancel-btn">
              <i className="bi bi-x-lg"></i>
              Annuler
            </Link>
            <button type="submit" className="submit-btn">
              <i className="bi bi-check-lg"></i>
              Créer le magasin
            </button>
          </div>
        </form>
      </div>
    </>
  );
};
export default CreateMagasinUpgraded;